import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getAppDisplayConfig, getBlogsSection, getChallengeOfTheDay, getDoYouKnowSection, getEventsSection, getHeroSection, getMoreChallengesSection, getPartnersSection, setAppDisplayConfig, setBlogsSection, setDoYouKnowSection, setEcoQuizzes, setEventsSection, setHeroSection, setMoreChallengesSection, setNewChallengeOfTheDay, setPartnersSection, getEcoActivitiesSection, setEcoActivitiesSection } from '../api/homepageOrganizer';

export const useGetCurrentChallengeOfTheDay = () => {
    return useQuery({
        queryKey: ['challenge-of-the-day'],
        queryFn: () => getChallengeOfTheDay(),
    });
};

export const useSetNewChallengeOfTheDay = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: (data) => setNewChallengeOfTheDay(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['challenge-of-the-day']);
        },
    });
}

export const useGetAppDisplayConfig = () => {
    return useQuery({
        queryKey: ['app-display-config'],
        queryFn: () => getAppDisplayConfig(),
    });
}

export const useUpdateAppDisplayConfig = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: (data) => setAppDisplayConfig(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['app-display-config']);
        },
    });
}

export const useUpdateEcoQuizzes = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationKey: ['set-eco-quizzes'],
        mutationFn: (data) => setEcoQuizzes(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['eco-quiz-list']);
        },
    });
}

// Hero Section
export const useGetHeroSection = () => {
    return useQuery({
        queryKey: ['hero-section'],
        queryFn: () => getHeroSection(),
        refetchOnWindowFocus: false,
    });
}

export const useSetHeroSection = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ data, heroImage1, heroImage2, deleteHeroImage1, deleteHeroImage2 }) => setHeroSection(data, heroImage1, heroImage2, deleteHeroImage1, deleteHeroImage2),
        onSuccess: () => {
            queryClient.invalidateQueries(['hero-section']);
        },
    });
}

// Do You Know Section
export const useGetDoYouKnowSection = () => {
    return useQuery({
        queryKey: ['do-you-know-section'],
        queryFn: () => getDoYouKnowSection(),
    });
}

export const useSetDoYouKnowSection = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => setDoYouKnowSection(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['do-you-know-section']);
        },
    });
}

// More Challenges Section
export const useGetMoreChallengesSection = () => {
    return useQuery({
        queryKey: ['more-challenges-section'],
        queryFn: () => getMoreChallengesSection(),
    });
}

export const useSetMoreChallengesSection = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => setMoreChallengesSection(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['more-challenges-section']);
        },
    });
}

// Blogs
export const useGetBlogsSection = () => {
    return useQuery({
        queryKey: ['blogs-section'],
        queryFn: () => getBlogsSection(),
    });
}

export const useSetBlogsSection = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => setBlogsSection(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['blogs-section']);
        },
    });
}

// Events Section
export const useGetEventsSection = () => {
    return useQuery({
        queryKey: ['events-section'],
        queryFn: () => getEventsSection(),
    });
}

export const useSetEventsSection = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => setEventsSection(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['events-section']);
        },
    });
}

// Partners
export const useGetPartnersSection = () => {
    return useQuery({
        queryKey: ['partners-section'],
        queryFn: () => getPartnersSection(),
    });
}

export const useSetPartnersSection = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => setPartnersSection(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['partners-section']);
        },
    });
}

// Eco Activities
export const useGetEcoActivitiesSection = () => {
    return useQuery({
        queryKey: ['eco-activities-section'],
        queryFn: () => getEcoActivitiesSection(),
    });
}

export const useSetEcoActivitiesSection = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => setEcoActivitiesSection(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['eco-activities-section']);
        },
    });
}